var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.9 53.5",
    style: {
      enableBackground: "new 0 0 51.9 53.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,49.4c-9.9-1-18.6-9.2-19.9-19.2c-1-10,4.7-19.4,13.9-23.2c5.8-2.3,12.4-3.4,18.5-1.7 c2.7,0.6,5.3,1.8,7.5,3.5c1.9,1.6,3.4,3.5,4.5,5.6c5,9.6,3.4,23.4-4.9,30.7c-2.2,1.9-4.8,3.3-7.7,4.1c-2.4,0.6-6.9,1.5-8.2-1.4 c-0.5-1.4-0.8-2.8-0.8-4.3c-0.2-1.6-0.4-3.3-0.5-4.9c-0.2-3.2-0.2-6.4-0.1-9.6l-1.2,0.9c0.8,0.1,2.8,0.3,3,1.3c0.2,1.3-2.7,1-3.3,1 C20.9,32.3,19,32.2,17,32s-1.2-2-0.4-3.2c1.1-1.5,2.3-2.9,3.5-4.3c1.2-1.4,2.1-2.7,3.3-3.9c0.9-0.9,2.4-2.4,3.5-1.1 c1.1,1.5,2,3,2.8,4.6c1.8,3,3.4,6.1,4.8,9.4l0.9-1.5c-1.7,0.1-3.3,0-5-0.1c-1.4-0.1-1.8,2-0.4,2.1c1.8,0.2,3.7,0.2,5.5,0.1 c0.6-0.1,1-0.6,1-1.2c0-0.1,0-0.2-0.1-0.2c-1.7-4.1-3.8-8.1-6.2-11.9c-1-1.7-2-4.1-4.3-4.1c-2,0-3.5,1.6-4.8,3 c-1.8,2-3.4,4.1-5.1,6.2c-1.2,1.5-2.7,3.1-2.6,5.1c0.1,2.3,2.2,2.9,4.1,3.1c2.4,0.2,5,0.7,7.4,0.3c1.9-0.3,3.8-1.7,3.1-3.8 c-0.6-1.9-2.9-2.6-4.6-2.7c-0.5-0.1-1.2,0.3-1.2,0.9c-0.2,3.2-0.2,6.4,0,9.6c0.1,3,0.5,6,1.1,9c0.3,1.2,0.9,2.4,1.8,3.2 c1.2,0.9,2.8,1.4,4.3,1.3c2.9,0,5.7-0.6,8.3-1.8c11.7-5.4,16-19.8,12.7-31.6C49.1,13.3,45.9,8.3,41,5.5c-2.9-1.5-6-2.6-9.2-3 C28.4,2.1,25,2.3,21.7,3.2c-5.8,1.3-11.2,3.5-15.2,8c-3.7,4-6,9.2-6.5,14.6c-1.1,12.7,9.2,24.4,21.7,25.7C23,51.6,23.4,49.5,22,49.4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.ab00f5a0732a7fb2a1085119c75438e9.svg";
export { ForwardRef as ReactComponent };